var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgValid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9998 38.3334C30.1251 38.3334 38.3332 30.1253 38.3332 20.0001C38.3332 9.87486 30.1251 1.66675 19.9998 1.66675C9.87462 1.66675 1.6665 9.87486 1.6665 20.0001C1.6665 30.1253 9.87462 38.3334 19.9998 38.3334Z",
    fill: "url(#paint0_linear_432:839)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8332 20.0001C37.8332 29.8492 29.8489 37.8334 19.9998 37.8334C10.1508 37.8334 2.1665 29.8492 2.1665 20.0001C2.1665 10.151 10.1508 2.16675 19.9998 2.16675C29.8489 2.16675 37.8332 10.151 37.8332 20.0001Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9406 18.6286C14.1847 17.8896 12.9671 17.8974 12.221 18.6461C11.4749 19.3947 11.4827 20.6007 12.2386 21.3398L17.125 26.1174C17.9289 26.9034 19.2404 26.8371 19.9593 25.9741L27.8933 16.4503C28.5693 15.6389 28.4532 14.4384 27.634 13.7689C26.8148 13.0994 25.6027 13.2144 24.9267 14.0258L18.3308 21.9434L14.9406 18.6286Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_432:839",
    x: -10.3335,
    y: -10.3333,
    width: 60.6665,
    height: 60.6667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_432:839"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_432:839",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_432:839",
    x1: 19.9998,
    y1: 1.66675,
    x2: 19.9998,
    y2: 38.3334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DD598",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DD598"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValid);
export default __webpack_public_path__ + "static/media/valid.e195d260.svg";
export { ForwardRef as ReactComponent };